import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Button, Table, Tag, Select, Pagination } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-regular-svg-icons";
import ShopPopup from "./popup";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import Notification from "../../services/Notification";

const List = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [details, setDetails] = useState();
  const [pageDetails, setPageDetails] = useState([]);
  const timerId = useRef(null);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [updatedAt, setUpdatedAt] = useState(1);
  const [count, setCount] = useState(1);

  useEffect(() => {
    (async () => {
      try {
        const data = await axios
          .get("/variant-list", {
            params: {
              limit,
              page,
            },
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (data && data.data) {
          setPageDetails(data.data.data);
          setCount(data.data.count);
        }
      } catch (error) {
        Helper.ErrorHanlder(error);
      }
    })();
  }, [limit, page, updatedAt]);

  const columns = [
    {
      title: "Variant Name",
      dataIndex: "name",
    },
    {
      title: "Web",
      dataIndex: "web",
      render: (text, record) => (
        <Tag
          role="button"
          color={record.web === false ? "#f50" : "#87d068"}
          onClick={() => {
            updateWebStatus(record);
          }}
        >
          {record.web ? "ACTIVATE" : "DEACTIVATE"}
        </Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "active",
      render: (text, record) => (
        <>
          <Tag
            role="button"
            color={record.active === false ? "#f50" : "#87d068"}
            onClick={() => {
              updateStatus(record);
            }}
          >
            {record.active ? "ACTIVATE" : "DEACTIVATE"}
          </Tag>
          <FontAwesomeIcon
            role="button"
            icon={faEdit}
            onClick={() => {
              setDetails(record);
              setOpenPopup(true);
            }}
          />
        </>
      ),
    },
  ];

  function closeModelPopup(data) {
    setOpenPopup(false);
    if (data) {
      setUpdatedAt(Date.now());
      Notification.success("Updated Successfully");
    }
  }

  const updateStatus = async (details) => {
    try {
      let obj = { id: details.id, active: !details.active };
      const data = await axios.post("/variant-create", obj).catch((error) => {
        Helper.ErrorHanlder(error);
      });
      if (data && data.data) {
        setUpdatedAt(Date.now());
        Notification.success(" Status updated successfully");
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const updateWebStatus = async (details) => {
    let obj = { id: details.id, web: !details.web };
    const data = await axios
      .patch("/update-web-status-variant", obj)
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      setUpdatedAt(Date.now());
      Notification.success("Staus updated successfully");
    }
  };

  const handleChange = (value) => {
    setPage(1);
    setLimit(value);
  };

  return (
    <Container>
      <Row>
        <Col md={12}>
          <div>
            <div className="deactive-btn">
              <Button
                type="primary"
                className="addnew-btn"
                onClick={(e) => {
                  setDetails("");
                  setOpenPopup(true);
                }}
              >
                Add New
              </Button>
            </div>
            <Table
              columns={columns}
              dataSource={pageDetails}
              pagination={false}
              rowKey="id"
            />
            <div className="pagination">
              <Select
                defaultValue={limit}
                style={{ width: 120 }}
                onChange={handleChange}
                options={[
                  {
                    value: 5,
                    label: "5",
                  },
                  {
                    value: 10,
                    label: "10",
                  },
                  {
                    value: 20,
                    label: "20",
                  },
                  {
                    value: 25,
                    label: "25",
                  },
                ]}
              />
              <Pagination
                defaultCurrent={page}
                pageSize={limit}
                showSizeChanger={false}
                total={count}
                onChange={setPage}
              />
            </div>
          </div>
        </Col>
      </Row>
      {openPopup && (
        <ShopPopup show={openPopup} close={closeModelPopup} details={details} />
      )}
    </Container>
  );
};

export default List;
